import { useEffect } from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsentBanner from "@/components/CookieConsentBanner";
import WelcomeModal from "@/components/WelcomeModal";
import SmoothScroll from "@/components/system/SmoothScroll";
import ScrollToTop from "@/components/system/ScrollToTop";
import GAPageTracker from "@/components/system/GAPageTracker";
import { isLocale, DEFAULT_LOCALE } from "@/i18n";

export default function Layout() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (isLocale(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);

  if (!isLocale(lang)) {
    return <Navigate to={`/${DEFAULT_LOCALE}`} replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <SmoothScroll />
      <ScrollToTop />
      <GAPageTracker />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CookieConsentBanner />
      <WelcomeModal />
    </div>
  );
}